module.exports = __webpack_public_path__ + "img/yinyanghuoke.aadd54e2.png";